import React from 'react';

// import DashboardIcon from '@material-ui/icons/Dashboard';
// import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import EmojiPeople from '@material-ui/icons/EmojiPeople';
import StorefrontIcon from '@material-ui/icons/Storefront';

import ListItemLink from './ListItemLink';


function MainListItems(accessLevel) {

  return (
    <div>

      {/* <ListItemLink
        icon={<DashboardIcon />}
        primary="Dashboard"
        to="/dashboard" 
    /> */}

      <ListItemLink
        icon={<EmojiPeople />}
        primary="Kunder"
        to="/kunder"
      />

      {/* <ListItemLink
      icon={<StorefrontIcon />}
      primary="Röda dagar"
      to="/rodadagar" 
    />  */}


    {
      accessLevel === 10 && 
      <>
      <ListItemLink
        icon={<StorefrontIcon />}
        primary="Butiker"
        to="/butiker"
      />

      <ListItemLink
        icon={<PeopleIcon />}
        primary="Admin-användare"
        to="/admin-anvandare"
      />
      </>
    }
      
    </div>
  );

}

const SecondaryListItems = (
  <div>
    {/* <ListSubheader inset>Saved reports</ListSubheader>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItem> */}
  </div>
);

export { MainListItems, SecondaryListItems };